import { FC } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export type MenuItemType = {
    link: string;
    text: string;
};

export type SideMenuProps = {
    items: MenuItemType[];
    handleCallback?: any;
};

const SideMenu: FC<SideMenuProps> = ({ items, handleCallback }) => {
    const { useState } = useGlobal();
    const [open, setOpen] = useState(false);

    const handleClick = (item: MenuItemType) => {
        handleCallback && handleCallback(item);
        setOpen(!open);
    };

    return (
        <div className={`side-menu ${css['side-menu']}`}>
            <ul className={`menu-box ${open ? 'open' : 'close'}`}>
                {items?.map((item: MenuItemType) => (
                    <li className="menu-item" key={item.link} onClick={() => handleClick(item)}>
                        <a href={item.link} className="menu-item-link">
                            {item.text}
                        </a>
                    </li>
                ))}
            </ul>
            <div className="icon-box">
                <div className="icon-inner-box" onClick={() => setOpen(!open)}>
                    {open ? (
                        <svg className="icon-close icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M6.70703 5.70703L18.2928 17.2928M18.2928 5.70703L6.70703 17.2928"
                                stroke="#757575"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M8 6H20M8 12H20M8 18H20" stroke="black" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4 6H5M4 12H5M4 18H5" stroke="black" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    )}
                </div>
            </div>
            <style global jsx>
                {`
                    #allContentContainer {
                        z-index: 101;
                    }
                `}
            </style>
        </div>
    );
};

export default SideMenu;
